<template>
  <div id="app">
    <!--    <keep-alive exclude="Detail">-->
    <router-view />
    <!--    </keep-alive>-->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* #app {} */

</style>



// WEBPACK FOOTER //
// src/App.vue